import { useState, useEffect } from 'react';
import { acquireToken } from '../authConfig';
import { trackError } from '../appinsights/applogs';

export default function useFetch(url, ref) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    acquireToken().then((response) => {
      if (ref.current) {
        (async () => {
          try {
            // Build headers with auth token if available
            const headers = {};
            if (response && response.accessToken) {
              headers.Authorization = 'Bearer ' + response.accessToken;
            }
            
            const res = await fetch(url, { headers });
            
            if (!res.ok) {
              throw new Error(`API Error ${res.status}: ${res.statusText}`);
            }
            
            const resJson = await res.json();
            setData(resJson);
          } catch (err) {
            trackError(err);
            setError(err);
          } finally {
            setLoading(false);
          }
        })();
      }
      return () => {
        ref.current = false;
      };
    }).catch((err) => {
      trackError(err);
      setError(err);
      setLoading(false);
    });
  }, [url, ref]);
  return { data, loading, error };
}
